export class Nomina {
  public IdLegajo: number;
  public Apellido: string;
  public Nombre: string;
  public FechaNacimiento: Date;
  public Cuil: number;
  public IdEmpresa: number;
  public IdUsuario: number;
  public Dni: number;
  public FechaIngreso: Date;
  public FechaEgreso: Date;
  public Seccion: string;
  public AntiguedadStr: string;
  public Antiguedad: number;
  public Edad: number;
  public Seleccionado: boolean;
  public Hovered: boolean;
  public Sucursal: string;
  public ApellidoNombre: string;

}
